function Percentage(value: number, total: number) {
    if ((value === total) && (total !== 0)) { return 0; }
    const per = (value / total) * 100;
    return per;
}
export default Percentage;